module.exports = __webpack_public_path__ + "6eabf9058b9f7b6f7dd6e3ca895b9392.glb";